module.exports = __webpack_public_path__ + "static/neufile-grotesk-bold-d654c4b466b6b32c62d74480d7de27ee.woff2";